import DATA_MODEL_TABLE from "../../utils/constants/dataModelTable";
import { changeDateFormat, convertToSnakeCase } from "../../utils/helpers/text";
import { getFieldValue } from "../booking-instruments/helpers";

const DateRender = (params) => {
  if (
    params?.column?.colId === convertToSnakeCase(DATA_MODEL_TABLE.dateOfNextMaintanance?.key) &&
    params?.data[convertToSnakeCase(DATA_MODEL_TABLE.dateOfNextMaintanance?.key)]
  ) {
    return (
      <div>
        {changeDateFormat(
          getFieldValue(params?.data, convertToSnakeCase(DATA_MODEL_TABLE.dateOfNextMaintanance.key)),
          "DD-MMM-YYYY"
        )}
      </div>
    );
  }
  if (
    params?.column?.colId === convertToSnakeCase(DATA_MODEL_TABLE.dateOfLastMaintanance?.key) &&
    params?.data[convertToSnakeCase(DATA_MODEL_TABLE.dateOfLastMaintanance?.key)]
  ) {
    return (
      <div>
        {changeDateFormat(
          getFieldValue(params?.data, convertToSnakeCase(DATA_MODEL_TABLE.dateOfLastMaintanance.key)),
          "DD-MMM-YYYY"
        )}
      </div>
    );
  }
  if (
    params?.column?.colId === convertToSnakeCase(DATA_MODEL_TABLE.dateOfNextPeriodicReview?.key) &&
    params?.data[convertToSnakeCase(DATA_MODEL_TABLE.dateOfNextPeriodicReview.key)]
  ) {
    return (
      <div>
        {changeDateFormat(
          getFieldValue(params?.data, convertToSnakeCase(DATA_MODEL_TABLE.dateOfNextPeriodicReview.key)),
          "DD-MMM-YYYY"
        )}
      </div>
    );
  }
  return <div>-</div>;
};

export default DateRender;
